import { NextPage, NextPageContext } from "next";
import InsightUltimateContainer from "@containers/Insight/Ultimate/Insight";
import Header from "@layouts/Main/lib/Header";
import { canonicalLink } from "@helpers/url";
import { getInsightList } from "@libraries/api/insight-list/insight-list.repos";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";
import useResponsive from "@helpers/useResponsive";
import Mobile from "@containers/Insight/libs/MobilePwa";

const Insight: NextPage<any> = ({ dataNavbar, insightList }) => {
  const mdClient = useResponsive("md", true);

  if (mdClient) {
    return (
      <Mobile insightList={insightList} />
    );
  }

  return (
    <>
      <Header
        setExpand={function (): void {
          throw new Error("Function not implemented.");
        }}
        withoutNavigation
      />
      <InsightUltimateContainer insightList={insightList} dataNavbar={dataNavbar} />
    </>
  );
};

export async function getServerSideProps({ locale, }: NextPageContext) {
  const EN = locale === "en";

  const { data: levelOneList } = await getProductMenu({ level: 0 }, locale ?? "id");
  const { data: dataInsightList } = await getInsightList({ page: 1 }, locale || "id");
  const responseInsightList = JSON.parse(JSON.stringify(dataInsightList));

  return {
    props: {
      ...(await serverSideTranslations(locale ?? "id", localeKey)),
      title: EN ? "Find Out How MyTEnS Helps Business and Enterprise" : "Cari Tahu Bagaimana MyTEnS Membantu Banyak Perusahaan",
      description: EN
        ? "Find the latest insights and information regarding various MyTenS solutions and services to help business development"
        : "Temukan berbagai wawasan dan informasi terbaru terkait berbagai solusi dan layanan MyTenS dalam membantu pengembangan bisnis",
      canonical: canonicalLink("/insight", locale),
      dataNavbar: levelOneList,
      insightList: responseInsightList,
    },
  };
}

export default Insight;
